import script from "./MigratePoolsInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MigratePoolsInfo.vue?vue&type=script&setup=true&lang=ts"

import "./MigratePoolsInfo.vue?vue&type=style&index=0&id=d31fb39c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d31fb39c"]])

export default __exports__